export class NewsletterTemplateModel {
    name: string;
    htmlContent: string;
    cssContent: string;
    templateContent: string;
    projectData : any;
    createdDate : Date;
    updatedDate : Date;
}